import {
  MarketingData,
  RegisterNewSetp1LoginInformationValues,
  RegisterNewSetp1PersonalInformationValues,
} from "@screens/register-new/step-1/setp1.component";
import CustomerKYCData from "../types/company-kyc-first";
import CompanyKYCData from "../types/freelancer-kyc-first";
import $axios from "../utils/axios";
import { toast } from "react-hot-toast";
import {
  RegisterNewSetp2CompanyValues,
  RegisterNewSetp2CustomerUsageDescriptionValues,
} from "@screens/register-new/step-2/setp2.component";
import { getCookie } from "@utils/general";
export interface Customer {
  customer_id: number;
  customer_name: string;
  customer_type: number;
  customer_login_name: string;
  customer_login_pwd: string;
  customer_active: number;
  customer_register_date: string;
  customer_dashboard_email: string;
  customer_dashboard_pwd: string;
  customer_alerts_email: string;
  is_to_block: number;
  is_auto_renewal: number;
  renewal_retries: number;
  revshare_percentage: number;
  affiliate_id: number;
  vat_percentage: number;
  customer_country_id: number;
  minimum_success_packet_size_bits: number;
  priority_id: string;
  priority_company_id: string;
  priority_name: string;
  priority_address: string;
  priority_address_2: string;
  priority_address_3: string;
  priority_contact_name: string;
  trial_monthly_package: number;
  trial_monthly_allocated: number;
  can_open_trials: number;
  reciept_day: number;
  max_level_price: number;
  is_stress_customer: number;
  customer_sub_domain: string;
  has_dedicated_servers: number;
  dedicated_servers_hours: number;
  online_payment: number;
  owner: number;
  commission: number;
  manualy_filled: number;
  zone_code: number;
  notes: string;
  is_notified_began_to_use: number;
  customer_segment: number;
  is_live_monitor: number;
  is_collect_full_data: number;
  is_sent_48_hours_active: number;
  is_sent_logged_in: number;
  referral_code: string;
  snkrs_private_pool: string;
  is_to_show_whitelist: number;
  is_self_register: number;
  is_login_pwd: string;
  is_proxy_pwd: string;
  is_kyc: number;
  kyc_email: "int unsigned";
  is_freelancer: number;
  unique_id: string;
  stripe_customer_id: string;
  stripe_payment_method: string;
  source_type: number;
  is_residential: number;
  is_first_login: number;
  freshsales_id: string;
  is_intro_email: number;
  freshsales_account_id: string;
  freshsales_owner_id: string;
  platform: string;
  phone: string;
  qq: string;
  ds3secure: boolean;
  dashboard_blocked: boolean;
  ref: string;
  browse_ai_agreement: boolean;
  register_ip: string;
  is_collect_domains: boolean;
  twilio_otp: boolean;
  added_to_table_2: boolean;
  is_header_ip: boolean;
  checkout_type: number;
  added_to_google_sheet: "tinyint";
  paddle_invoice_customer_id: string;
  paddle_invoice_current_invoice: string;
  hubspot_id: string;
  hubspot_company_id: string;
  hubspot_owner_id: string;
  is_lta: boolean;
  lta_type: number;
  source_website: string;
  authy_id: number;
  two_fa_secret_reports: string;
  is_logged_2fa_reports: boolean;
  two_fa_secret_portal: string;
  is_logged_2fa_portal: boolean;
  is_2fa_reports: boolean;
  is_2fa_portal: boolean;
  first_owner?: number;
}
interface KycSegments {
  bandwidth: string;
  countries: any[];
  desc: string;
  proxy: string;
  customer_id: number;
  cards: string[];
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_adgroup: string;
  utm_term: string;
}
interface NetnutReponse<D, E> {
  success: boolean;
  message: string;
  data?: D | D[];
  error?: E | E[];
}
type UpdateKycData = CustomerKYCData | CompanyKYCData;
class RegisterService {
  baseUrl: string;
  constructor() {
    this.baseUrl = `/register`;
  }
  async registerForm1(
    registerNewSetp1PersonalInformationValues: RegisterNewSetp1PersonalInformationValues,
    registerNewSetp1LoginInformationValues: RegisterNewSetp1LoginInformationValues,
    marketingData: MarketingData,
    reToken: string
  ): Promise<void> {
    const responseNewLead = await $axios.post<NetnutReponse<any, any>>(
      `${this.baseUrl}/step-1`,
      {
        loginInformation: registerNewSetp1LoginInformationValues,
        personalInformation: registerNewSetp1PersonalInformationValues,
        marketing: marketingData,
        reToken,
      }
    );
    if (!responseNewLead.data.success)
      toast.error(responseNewLead.data.message);
    if (responseNewLead.data.success)
      toast.success(responseNewLead.data.message);
  }
  async registerForm2(
    registerNewSetp2CompanyValues: RegisterNewSetp2CompanyValues,
    registerNewSetp2CustomerUsageDescriptionValues: RegisterNewSetp2CustomerUsageDescriptionValues,
    marketingData: MarketingData,
    isCompany: boolean,
    reToken: string
  ): Promise<any> {
    registerNewSetp2CustomerUsageDescriptionValues.products = (
      registerNewSetp2CustomerUsageDescriptionValues.products as string[]
    ).join(",");

    const responseNewLead = await $axios.post<NetnutReponse<any, any>>(
      `${this.baseUrl}/step-2`,
      {
        customerUsageDescription:
          registerNewSetp2CustomerUsageDescriptionValues,
        company: { ...registerNewSetp2CompanyValues, isCompany },
        marketing: marketingData,
        reToken,
      }
    );
    if (!responseNewLead.data.success)
      toast.error(responseNewLead.data.message);
    if (responseNewLead.data.success)
      toast.success(responseNewLead.data.message);
    return responseNewLead.data;
  }

  async verifyRegsiter(
    registerNewSetp1PersonalInformationValues: RegisterNewSetp1PersonalInformationValues,
    registerNewSetp1LoginInformationValues: RegisterNewSetp1LoginInformationValues,
    marketingData: MarketingData,
    otpToken: string,
    reToken: string
  ): Promise<{ success: boolean; customer: Customer; token: string }> {
    const responseNewCustomer = await $axios.post<
      NetnutReponse<{ customer: Customer; token: string }, any>
    >(`${this.baseUrl}/step-1-verify`, {
      payload: {
        loginInformation: registerNewSetp1LoginInformationValues,
        personalInformation: registerNewSetp1PersonalInformationValues,
        hubspotutk: getCookie("hubspotutk"),
        marketing: marketingData,
      },
      otpToken,
      reToken,
    });
    if (!responseNewCustomer.data.success)
      toast.error(responseNewCustomer.data.message);
    if (responseNewCustomer.data.success)
      toast.success(responseNewCustomer.data.message);
    if (Array.isArray(responseNewCustomer.data.data))
      throw new Error("Unexcpected data");
    return {
      success: responseNewCustomer.data.success,
      customer: responseNewCustomer!.data!.data!.customer,
      token: responseNewCustomer.data!.data!.token,
    } as { success: boolean; customer: Customer; token: string };
  }
  async updateKyc(data: UpdateKycData, files: File[] = []): Promise<any> {
    let body = files.reduce((formdata: any, file: File) => {
      formdata.append("files", file);
      return formdata;
    }, new FormData());
    body = Object.entries(data).reduce((formdata: any, [key, val]: any[]) => {
      formdata.append(key, val);
      return formdata;
    }, body);
    const subUsers = await $axios.post(`${this.baseUrl}/kyc/first`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return subUsers.data;
  }

  async updateKycSegments(data: KycSegments): Promise<any> {
    const subUsers = await $axios.post(`${this.baseUrl}/kyc/second`, {
      ...data,
    });
    return subUsers.data;
  }
  async sendOtp(email: string): Promise<void> {
    const responseOtp = await $axios.post(`${this.baseUrl}/confirm`, {
      email,
    });
    if (!responseOtp.data.success) toast.error(responseOtp.data.message);
    if (responseOtp.data.success) toast.success(responseOtp.data.message);
  }
  // async uploadFiles(files: File[]): Promise<boolean> {

  //   const { data } = await $axios.post(`$${this.baseUrl}/upload`, body, );
  //   return data.success;
  // }
}

export default RegisterService;
